/* Forma canônica da resposta de ERRO do admin-service (ADR-0699). Todas as rotas do
   backoffice emitem `{ error: <code> }` num status HTTP != 2xx; este DTO fixa a forma para
   os dois lados (admin-service valida a saída; admin-web faz `safeParse` antes de mapear o
   código → mensagem pt-BR). O vocabulário de códigos é grande e evolui por domínio, então o
   `code` é `string` (o mapeamento por-código vive nos error-mappers do front); o que este
   contrato garante é a FORMA, não o enum. */
import { z } from 'zod';

export const errorResponseDto = z.object({ error: z.string().min(1) });
export type ErrorResponse = z.infer<typeof errorResponseDto>;
